import { SemanticCOLORS, SemanticICONS } from "semantic-ui-react";

export enum Role {
    Accounting = "Accounting",
    AccountingAdmin = "AccountingAdmin",
    AllowDeleteInsuredDocuments = "AllowDeleteInsuredDocuments",
    EmployeeViewSSN = "EmployeeViewSSN",
    FasanoUser = "FasanoUser",
    GenericAdmin = "Admin",
    InboundChennaiManager = "InboundChennaiManager",
    LITCOAccounting = "LITCOAccounting",
    MedRecMgr = "MedRecMgr",
    ServicingAdmin = "ServicingAdmin",
    ServicingInsuredTrackingAdmin = "ServicingInsuredTrackingAdmin",
    ServicingOptReview = "ServicingOptReview",
    ServicingPolicyManager = "ServicingPolicyManager",
    ServicingTrading = "ServicingTrading",
    ServicingUser = "Servicing",
    TrustCHBUser = "TrustCHBUser",
    TrustManager = "TrustManager",
    TrustUser = "TrustUser",
    Underwriting = "Underwriting",
    UWAdmin = "UWAdmin",
    UWSupportSr = "UWSupportSr"
}

export interface Client {
    ClientID: number;
    ClientName: string;
}

export interface Portfolio {
    ClientID: number;
    ClientName: string;
    PortfolioID: number;
    PortfolioName: string;
}

export interface ClientInsured {
    ClientID: number;
    InsuredID: number;
    ClientTrackingID: string | null;
    CaseManager: string;
    Tracking: boolean;
    Notes: string;
    ObitSweep: boolean;
    ClientInsuredID?: number;
    CreatedDate?: Date | string;
    DeathNotificationDate?: Date | string | null;
    CreatedBy?: string;
    UpdatedDate?: Date | string;
    UpdatedBy?: string;
}

export interface FileType {
    FileTypeID: number;
    Name: string;
    InsuredDoc?: boolean;
    PolicyDoc?: boolean;
    PortfolioDoc?: boolean;
}

export interface GenericFile {
    highlighted?: boolean;
    selected?: boolean;
}

export type pane = {
    menuItem: { className?: string; color: SemanticCOLORS; content: string; icon: SemanticICONS; key: string };
    render: () => React.ReactNode;
};
